<ng-container *transloco="let t">
  <div class="certificate-form">
    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Last Rabies vaccination') }}</mat-label>
      <textarea
        matInput
        rows="2"
        [formControl]="lastRabiesVaccination"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Last Contag.diseases vaccination') }}</mat-label>
      <textarea
        matInput
        rows="2"
        [formControl]="lastContagDiseasesVaccination"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Last treatment of endo/ectoparasites') }}</mat-label>
      <textarea
        matInput
        rows="2"
        [formControl]="lastTreatmentEndoEcto"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Last treatment of ectoparasites') }}</mat-label>
      <textarea matInput rows="2" [formControl]="lastTreatmentEcto"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Notes') }}</mat-label>
      <textarea matInput rows="2" [formControl]="notes"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput [formControl]="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
